import React from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.js";

import quote_text_1 from 'assets/img/use_cases_web/cat.png';
import quote_text_2 from 'assets/img/use_cases_web/sleep.png';
import quote_text_3 from 'assets/img/use_cases_web/sheep.png';
import quote_text_4 from 'assets/img/use_cases_web/owl.png';
import quote_text_5 from 'assets/img/use_cases_web/familly.png';


const useStyles = makeStyles(styles);

const AreaContainerGrid = props => {
  return  (
    <GridItem xs={12} sm={12} md={4}>
      <Card plain>
        <GridItem xs={12} sm={12} md={6} className={props.itemGrid}>
          <Box >
            <img src={props.imagepath} alt={props.title}  className={props.imageClasses} />
          </Box>
        </GridItem>
        <h4 className={props.cardTitle}>
          {props.title}
          <br />
        </h4>
        <CardBody>
          <p className={props.description}>
            {props.text}
          </p>
        </CardBody>
      </Card>
    </GridItem>
  )
}
const ProductSection = props => {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgFluid
  );
  return (

    <div className={classes.section}>
      <h1 className={classes.title}>How will you use it ?</h1>
      <div>
        <GridContainer>
          <AreaContainerGrid
            itemGrid = {classes.itemGrid}
            imagepath = {quote_text_1}
            imageClasses = {imageClasses}
            cardTitle = {classes.cardTitle}
            description = {classes.description}
            title = {'Draw a sketch of your cat'}
            text = {''}
          />

          <AreaContainerGrid
            cardTitle = {classes.cardTitle}
            description = {classes.description}
            imageClasses = {imageClasses}
            imagepath = {quote_text_2}
            itemGrid = {classes.itemGrid}
            text = {''}
            title = {'Make sure you wake up early'}
          />

          <AreaContainerGrid
            cardTitle = {classes.cardTitle}
            description = {classes.description}
            imageClasses = {imageClasses}
            imagepath = {quote_text_3}
            itemGrid = {classes.itemGrid}
            text = {''}
            title = {'Invite three of your friends to an escape game'}
          />

          <AreaContainerGrid
            cardTitle = {classes.cardTitle}
            description = {classes.description}
            imageClasses = {imageClasses}
            imagepath = {quote_text_4}
            itemGrid = {classes.itemGrid}
            text = {''}
            title = {'Complete your homework and have a free weekend'}
          />

          <AreaContainerGrid
            cardTitle = {classes.cardTitle}
            description = {classes.description}
            imageClasses = {imageClasses}
            imagepath = {quote_text_5}
            itemGrid = {classes.itemGrid}
            text = {' '}
            title = {'Call seven of your friends or family and ask about there doing'}
          />
        </GridContainer>
      </div>
    </div>
  );
}


ProductSection.propTypes = {
  className: PropTypes.string
};

export default ProductSection;

